import React from 'react'

import ValuePagesTemplate from '../components/ValuePagesTemplate'
import Text from '../components/Text'
import PageTitle from '../components/PageTitle'

const TrustPage = () => (
  <ValuePagesTemplate>
  	<PageTitle title='Trust' />
    <Text>We believe in autonomy and independence as a way to grow. We trust who we work with to take the lead.</Text>
    <Text>We expect mistakes and we take responsibility.</Text>
  </ValuePagesTemplate>
)

export default TrustPage



// WEBPACK FOOTER //
// ./src/pages/trust.js